// extracted by mini-css-extract-plugin
export default {"container":"ReportTypeSelector_container__SFMX7","label":"ReportTypeSelector_label__6aLix","select":"ReportTypeSelector_select__Q0DbY"};